import React from 'react'
// import { Link } from 'react-router-dom';


const Blog2 = () => {

    return (
        <>
<>
  <section className="main-wrapper bg-grey">
    <div className="container">
      <div className="main-content mt-20 ov-hidden">
        <div className="col-md-8 sm-padding">
          <div className="blog-details padding-25 bg-white bd-grey mb-30">
            <h2 className="mb-5 fw-6">
              मैं तो आर्थिक अभाव के कारण खेला नहीं सका लेकिन मैं चाहता हूं हमारे
              कोशी - सीमांचल के बच्चे खेलें और ओलंपिक तक जाएं :- संजीव मिश्रा
            </h2>
            <img src="img/sanjay-misra.jpg" alt="" className="img-w1" />
            <div className="meta-info mb-25 mt-5">
              <span className="mt-5">
                <i className="ti-calendar fz-18" />{" "}
                <a >27 Augest, 2024</a>
              </span>
              {/* <span>
                          <i class="ti-user fz-18"></i> Written by <a >David Cameroon</a>
                      </span>
                      <span>
                          <i class="ti-bookmark fz-18"></i> Tagged as <a >Wordpress Development</a>
                      </span> */}
            </div>
            {/* blog-details */}
            <p>
              <span className="head-line-text">पूर्णिया:</span> पैनोरमा
              स्पोर्ट्स सीजन -7 के आयोजन हेतु विभिन्न खेलों के पदाधिकारीयों ,
              खेल प्रशिक्षक, अंपायर, स्कोरर एवं मैच रेफरी की महत्वपूर्ण बैठक को
              संबोधित करते हुए पैनोरमा ग्रुप के चेयरमैन व अध्यक्ष पैनोरमा
              स्पोर्ट्स श्री संजीव मिश्रा ने कहा कि मैं तो आर्थिक अभाव के कारण
              खेल नहीं सका । लेकिन मैं चाहता हूं कि कोशी - सीमांचल के बच्चे
              खेलें और बिहार का नाम रौशन करें। और अपनी प्रतिभा के बदौलत ओलंपिक
              में खेले। यही मेरी कामना है।
            </p>
            <p>
              श्री संजीव मिश्रा ने कहा कि हम सबों को अपनी - अपनी क्षमताओं के
              अनुसार विभिन्न खेलों को बढ़ावा देने का प्रयास करना चाहिए। सभी के
              प्रयास से एक दिन हमारे कोशी - सीमांचल एवं बिहार के बच्चे अवश्य
              ओलंपिक में जाएंगे। समय जो लग जाए।
            </p>
            <p>
              पैनोरमा स्पोर्ट्स सीजन -7 आयोजन समिति सदस्य हरिओम झा ने कहा
              पैनोरमा ग्रुप के चेयरमैन व अध्यक्ष पैनोरमा स्पोर्ट्स श्री संजीव
              मिश्रा "सर" की प्रयास एवं आर्थिक सहयोग प्रशांसनीय है। जितनी भी
              तारीफ की जाए वह काम है। हर वर्ष विभिन्न खेलों में खिलाड़ियों को
              खेलने का अवसर प्रदान कर रहे हैं। विभिन्न खेलों के पदाधिकारियों ,
              खेल प्रशिक्षक , अंपायर, स्कोरर एवं मैच रेफरी से अनुरोध है कि अपने
              - अपने खेलों से सम्बंधित सभी नियम एवं शर्तें यथाशीघ्र उपलब्ध करा
              दें।
            </p>
            <p>
              पैनोरमा कॉरपोरेट कार्यालय में विभिन्न खेलों के पदाधिकारियों की
              बैठक कर कई अहम् निर्णय लिए गए।
            </p>
            <p>
              पैनोरमा स्पोर्ट्स सीजन -7 की शुरुआत दिनांक 22 सितंबर 2024 से
              पैनोरमा ई होम्स स्पोर्ट्स कॉम्प्लेक्स परिसर पूर्णिया में होने जा
              रही है।
            </p>
            <p>
              पैनोरमा स्पोर्ट्स सीजन -7 की समापन समारोह दिनांक 22 नवंबर 24 को
              पैनोरमा ई होम्स स्पोर्ट्स कॉम्प्लेक्स परिसर पूर्णिया में आयोजित
              होगा । जिसमें सभी विधाओं के विजेताओं एवं उप-विजेता को नगद पुरस्कार
              राशि से पुरस्कृत किया जाएगा। एवं ट्रॉफी भी दिए जाएंगे।
            </p>
            <ol>
              नि: शुल्क प्रतियोगिता:-
              <li>1.क्रिकेट</li>
              <li>2. वॉलीबॉल</li>
              <li>3. बास्केटबॉल</li>
              <li>4. बैडमिंटन</li>
              <li>5. टेबुल टेनिस</li>
              <li>6. फुटबॉल </li>
              <li>7. कुश्ती</li>
              <li>8. कबड्डी </li>
              <li>9. एथलेटिक्स </li>
              <li>10. साइकिलिंग </li>
              <li>11. हॉर्सराइटिग</li>
              <li>12. शतरंज </li>
            </ol>
            <ol>
              {" "}
              प्रतियोगिता अंडर - 17 आयु वर्ग में बालक - बालिका आयु वर्ग के साथ -
              साथ एवं ओपन टू आल आयु वर्ग में खेला जाएगा। शतरंज प्रतियोगिता :-
              <li>1. अंडर -7</li>
              <li>2. अंडर -9</li>
              <li>3. अंडर -11</li>
              <li>4. अंडर -17</li>
            </ol>
            <ol>
              बालक , बालिका आयु वर्ग के साथ - साथ ओपन टू आल वर्ग में प्रतियोगिता
              खेला जाएगा । एथलेटिक्स प्रतियोगिता:-
              <li>1. 100 मीटर दौड़ </li>
              <li>2. 200 मीटर दौड़ </li>
              <li>3. 400 मीटर दौड़ </li>
              <li>4. 4.800 मीटर दौड़ </li>
              <li>5. 5.1500 मीटर दौड़ </li>
              <li>6. डिस्कस</li>
              <li>7. भाला ( जैवलिन) </li>
              <li>8. लंबी कूद </li>
              <li>9. ऊंची कूद</li>
              <li>10. गोला </li>
            </ol>
            <img
              src="img/purniya-bihar-sanjay.jpg"
              alt="headlines bihar"
              width={600}
            />
            <p>
              अंडर -17 बालक, बालिका आयु वर्ग के साथ - साथ ओपन टू आल वर्ग में रखा
              गया है।
            </p>
            <p>
              {" "}
              रजिस्ट्रेशन की अंतिम तिथि 15 सितंबर को रखा गया। बैठक को हरिओम
              झा,एम एच रहमान साहब, मो नैय्यर अली, विकास कुमार, विजय शंकर सिंह,
              मिथलेश राय, बिमल मुकेश, अजीत सिंह, रूबेन सोरेन, अमर कांत झा, अमृत
              साजन,पुनित कुमार सिंह आदि ने अपने खेलों से सम्बंधित विचार रखें।
            </p>
            <p>
              {" "}
              पैनोरमा स्पोर्ट्स सीजन -7 के सभी पहलुओं पर विचार - विमर्श कर यह
              निर्णय लिया गया कि ग्रामीण एवं शहरी क्षेत्रों के अधिक से अधिक
              विद्यालयों एवं खिलाड़ियों को जोड़ा जाए। और खेलों के प्रति जागरूक
              किया जाए।
            </p>
            <p>
              बैठक में शामिल हरिओम झा, मिथलेश राय, मो मंजर मोहशिम, एस एस प्रसाद
              पिंटू, बिमल मुकेश, रूबेन सोरेन, एम एच रहमान, विजय शंकर सिंह, अमर
              कांत झा, अमृत साजन, मोहम्मद एजाज अहमद, पुनीत कुमार सिंह, विकास
              कुमार, मोहम्मद अरशद राजा , बृजेश भास्कर, खुशी कुमारी, अराधना
              कुमारी, निभा कुमारी, अजीत सिंह,नवीन सिंह आदि बैठक में मौजूद थे।
            </p>
            <ul className="single-tags">
              <li>Tags</li>
              <li>
                <a >Sports</a>
              </li>
              <li>
                <a >Travel</a>
              </li>
            </ul>
            <div className="social-share-wrap">
              <span className="fz-16 text-black fw-6">Share This Article</span>
              <ul className="share-icon">
                <li>
                  <a >
                    <i className="ti-facebook" /> Facebook
                  </a>
                </li>
                <li>
                  <a >
                    <i className="ti-twitter" /> Twitter
                  </a>
                </li>
                <li>
                  <a >
                    <i className="ti-google" /> Google+
                  </a>
                </li>
              </ul>
            </div>
            {/* social-share-wrap */}
          </div>
          {/* /.blog-details */}
          {/* <div class="about-author padding-25 bg-white bd-grey mb-30">
                  <img src="img/author-thumb.jpg" alt="Author Thumb">
                  <div class="author-info">
                      <h3><a >John Doe</a></h3>
                      <p class="fz-13">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum sunt voluptatem soluta obcaecati ex hic maxime quod voluptates similique iusto. Earum sunt voluptatem soluta ex hic similique iusto.</p>
                      <ul class="social-icon-black social-left">
                          <li><a ><i class="ti-facebook"></i></a></li>
                          <li><a ><i class="ti-twitter"></i></a></li>
                          <li><a ><i class="ti-google"></i></a></li>
                      </ul>
                  </div>
              </div>/.about-author */}
        </div>
        {/* content block */}
        <aside className="col-md-4 sm-padding">
          <div className="sidebar-wrap">
            {/* <div class="single-sidebar bd-grey bg-white">
                      <a ><img src="img/banner-2.jpg" alt="Sidebar Ad" class="img-w1"></a>
                  </div>/.single-sidebar */}
            <div className="single-sidebar no-padding">
              <a
                href="https://www.accuweather.com/en/us/new-york-ny/10007/weather-forecast/349727"
                className="aw-widget-legal"
              >
                {/*
                          By accessing and/or using this code snippet, you agree to AccuWeather’s terms and conditions (in English) which can be found at https://www.accuweather.com/en/free-weather-widgets/terms and AccuWeather’s Privacy Statement (in English) which can be found at https://www.accuweather.com/en/privacy.
                          */}
              </a>
              <div
                id="awcc1499974479079"
                className="aw-widget-current"
                data-locationkey=""
                data-unit="c"
                data-language="en-us"
                data-useip="true"
                data-uid="awcc1499974479079"
              />
            </div>
            {/* /.single-sidebar */}
            <div className="single-sidebar no-padding">
              <div className="side-tab">
                <ul className="tab-menu mb-15">
                  <li className="active">
                    <a href="#recent" data-toggle="tab">
                      Recent
                    </a>
                  </li>
                  <li>
                    <a href="#popular" data-toggle="tab">
                      Popular
                    </a>
                  </li>
                  <li>
                    <a href="#comments" data-toggle="tab">
                      Comments
                    </a>
                  </li>
                </ul>
                <div className="tab-content bd-grey padding-15">
                  <div className="tab-pane fade in active" id="recent">
                    <ul className="list-post-items">
                      <li>
                        <img src="img/tab-1.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >William Braynt went to visit the US.</a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-2.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              Style icon angelina goes to take oscar.
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-3.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              How to become a wildlife photographer?
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-4.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              linin park singer is no more. he is top in the
                              world.
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>{" "}
                  {/* /#recent */}
                  <div className="tab-pane fade in" id="popular">
                    <ul className="list-post-items">
                      <li>
                        <img src="img/tab-1.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-2.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-3.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-4.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>{" "}
                  {/* /#popular */}
                  <div className="tab-pane fade in" id="comments">
                    <ul className="list-post-items">
                      <li>
                        <img src="img/tab-1.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-2.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-3.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-4.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2023
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>{" "}
                  {/* /#comments */}
                </div>
              </div>
            </div>
            {/* /.single-sidebar */}
            <div className="single-sidebar">
              <h3 className="fw-8 fz-18 tt-u mb-30">Subscribe News24</h3>
              <form action="#" className="subscribe-form">
                <input
                  type="email"
                  name="email"
                  placeholder="Enter Your Email"
                />
                <input type="submit" defaultValue="Subscribe" />
              </form>
            </div>
            {/* /.single-sidebar */}
            <div className="single-sidebar">
              <div id="calendar_wrap" className="calendar_wrap">
                <table id="wp-calendar">
                  <caption>Agust 2024</caption>
                  <thead>
                    <tr>
                      <th scope="col" title="Monday">
                        M
                      </th>
                      <th scope="col" title="Tuesday">
                        T
                      </th>
                      <th scope="col" title="Wednesday">
                        W
                      </th>
                      <th scope="col" title="Thursday">
                        T
                      </th>
                      <th scope="col" title="Friday">
                        F
                      </th>
                      <th scope="col" title="Saturday">
                        S
                      </th>
                      <th scope="col" title="Sunday">
                        S
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={3} id="prev" className="pad">
                        &nbsp;
                      </td>
                      <td className="pad">&nbsp;</td>
                      <td colSpan={3} id="next" className="pad">
                        &nbsp;
                      </td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr>
                      <td colSpan={5} className="pad">
                        &nbsp;
                      </td>
                      <td>1</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>6</td>
                      <td>7</td>
                      <td>
                        <a
                          href="http://cracktheme.com/codehube/2024/07/08/"
                          aria-label="Posts published on July 8, 2023"
                        >
                          8
                        </a>
                      </td>
                      <td>9</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>11</td>
                      <td>
                        <a
                          href="http://cracktheme.com/codehube/2024/07/12/"
                          aria-label="Posts published on July 12, 2023"
                        >
                          12
                        </a>
                      </td>
                      <td>
                        <a
                          href="http://cracktheme.com/codehube/2024/07/13/"
                          aria-label="Posts published on July 13, 2023"
                        >
                          13
                        </a>
                      </td>
                      <td>14</td>
                      <td>15</td>
                      <td>16</td>
                    </tr>
                    <tr>
                      <td>17</td>
                      <td>18</td>
                      <td>19</td>
                      <td id="today">20</td>
                      <td>21</td>
                      <td>22</td>
                      <td>23</td>
                    </tr>
                    <tr>
                      <td>24</td>
                      <td>25</td>
                      <td>26</td>
                      <td>27</td>
                      <td>28</td>
                      <td>29</td>
                      <td>30</td>
                    </tr>
                    <tr>
                      <td>31</td>
                      <td className="pad" colSpan={6}>
                        &nbsp;
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* /.single-sidebar */}
          </div>
          {/* /.sidebar-wrap */}
        </aside>
        {/* sidebar block */}
      </div>
      {/* /.main-content */}
    </div>
    {/* /.container */}
  </section>
  {/* /.main-wrapper */}
</>


        </>

    )
}

export default Blog2;